// Trusted-origin check for window.postMessage listeners (ANYGRC_Vulnerabilities:
// "postMessage Origin Not Validated in OAuth Popup Handlers").
//
// The OAuth callback popup (backend/routes/fan_routes.py) is served by the
// BACKEND, not the SPA. In production both are proxied under the same domain
// (anygrc.com) so the popup's origin equals window.location.origin. In local
// dev the SPA runs on :3030 while the backend runs on a different port
// (:5001 by default), so the popup's origin equals the backend's origin
// instead — read the same REACT_APP_API_BASE_URL the rest of the app uses
// (see services/apiService.ts) rather than hardcoding a port.
const rawApiBase = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || '';

function safeOrigin(url: string): string | null {
  try {
    return new URL(url).origin;
  } catch {
    return null;
  }
}

const API_ORIGIN = rawApiBase ? safeOrigin(rawApiBase) : null;

/** True if a postMessage event's origin is this app's own origin or its configured backend origin — never an attacker-controlled origin. */
export function isTrustedMessageOrigin(origin: string): boolean {
  if (origin === window.location.origin) return true;
  if (API_ORIGIN && origin === API_ORIGIN) return true;
  return false;
}
